import './App.css';
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Contact from "./pages/Contact";
import ScrollToTop from './components/common/ScrollToTop';

function App() {
  return (
    <Router>
      {/* Header appears on all pages */}
      <Header />

      <main className="min-h-screen">
        {/* Define Routes */}
        <ScrollToTop /> {/* Add this line */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      {/* Footer appears on all pages */}
      <Footer />
    </Router>
  );
}

export default App;
